import React from "react";
import propic from "../../../assets/images/propic.jpg";
import { FaCircle } from "react-icons/fa";
const Education = ({ classes }) => {
  return (
    <div className={`${classes}`} data-aos="zoom-in" data-aos-duration="1000">
      <div className="">
        <h3 className="text-4xl font-roboto font-extrabold text-green-500 text-start">
          <span>Education</span>
        </h3>
        <div className="flex items-start mt-8 px-5">
            <div className="text-green-500 mr-2 mt-1">
                <FaCircle />
            </div>
            <div className="text-white text-[18px]">
                    BSc (Engg) in CSE
                <div>
                    <div>
                        Graduation Completed At: 2022
                    </div>
                    <div>
                        North East University Bangladesh
                    </div>
                </div>
            </div>
        </div>
        
      </div>
    </div>
  );
};

export default Education;